import { Client } from "@xmpp/client"
import { getAllItems, publish } from "./PubSub"
import { Element } from "@xmpp/xml"
import XmppPubSubApi from "../xmppPubSubApi"
import { captureError } from "@/ErrorHandlers"
import { ChatSettings } from "@/reducers/chatsSettingsSlice"
import ChatSettingsParser from "@/lib/chatSettingsParser"

export const CHAT_SETTINGS_NODE = "urn:slickshift:chat-settings:0"

export const retrieveAllChatsSettings = async (
  xmpp: Client,
): Promise<ChatSettings[]> => {
  const userJid = xmpp.jid?.bare().toString() as string
  const nodeExists = await XmppPubSubApi.checkNodeExists(
    xmpp,
    userJid,
    CHAT_SETTINGS_NODE,
  )
  if (!nodeExists) {
    return []
  }
  try {
    const items = await getAllItems({
      xmpp,
      jid: userJid,
      node: CHAT_SETTINGS_NODE,
      timeout: 4000,
    })

    const elements = items
      .getChild("pubsub")
      ?.getChild("items")
      ?.getChildren("item") as [Element]

    return elements.map((element) => {
      return ChatSettingsParser.parseItem(element)
    })
  } catch (error: any) {
    return []
  }
}

export const publishChatSettings = async (
  client: Client,
  chatSettings: ChatSettings,
) => {
  const userJid = client.jid?.bare().toString() as string
  const payload = ChatSettingsParser.toXml(chatSettings)
  await publish({
    id: chatSettings.chatJid,
    xmpp: client,
    jid: userJid,
    node: CHAT_SETTINGS_NODE,
    payload,
    timeout: 4000,
  })
}

export const subscribeToChatsSettings = async (client: Client) => {
  const userJid = client.jid?.bare().toString() as string
  const nodeExists = await XmppPubSubApi.checkNodeExists(
    client,
    userJid,
    CHAT_SETTINGS_NODE,
  )
  if (nodeExists) {
    try {
      await XmppPubSubApi.subscribe(client, userJid, CHAT_SETTINGS_NODE)
    } catch (error: any) {
      if (error.condition !== "item-not-found") {
        captureError(error, {
          origin: "XMPPOnOnline",
          extra: { message: "subscribeToChatsSettings" },
        })
      }
    }
  }
}
